import React from "react";
import { Box, Typography, IconButton, Collapse, Paper } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PropTypes from "prop-types";

/**
 * CollapsibleSection - generic collapsible container
 * @param {string|React.ReactNode} header - Header content
 * @param {boolean} defaultOpen - Whether section starts open
 * @param {React.ReactNode} children - Section content
 * @param {object} headerSx - Optional extra styles for header
 */
export default function CollapsibleSection({
  header,
  open,
  onToggle,
  children,
  headerSx = {},
  sx,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: "1.5px solid #e0e0e0",
        borderRadius: 2,
        mb: 2,
        bgcolor: "rgb(247,247,247)",
        ...sx,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1.5}
        sx={{
          cursor: "pointer",
          bgcolor: "rgb(20, 53, 68)",
          borderRadius: "8px 8px 0 0",
          ...headerSx,
        }}
        onClick={onToggle}
      >
        <Typography sx={{ fontWeight: 700, fontSize: 18, color: "#fff" }}>
          {header}
        </Typography>
        <IconButton
          size="small"
          edge="end"
          aria-label="expand"
          sx={{ ml: 1, color: "#fff" }}
        >
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box p={2}>{children}</Box>
      </Collapse>
    </Paper>
  );
}

CollapsibleSection.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  defaultOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  headerSx: PropTypes.object,
};
